export default __webpack_public_path__ + "static/media/Apple.5537c0cb.PNG";